import { setErrorMessage } from 'shared/hooks/machines/setErrorMessage.js';
import {
  assign,
  type PromiseActorLogic,
  raise,
  setup,
} from 'xstate';

import { ReportingType } from './Helpdesk.constants.js';
import type {
  CreateHelpdeskTicketEvents,
  HelpdeskContextContext,
} from './Helpdesk.types.js';

export const initialState: HelpdeskContextContext = {
  modalOpen: false,
  errorMessage: undefined,
  data: {
    type: ReportingType.Suggestion,
    description: '',
    screenshot: true,
  },
};

export const createHelpdeskTicketMachine = setup({
  types: {
    context: {} as HelpdeskContextContext,
    events: {} as CreateHelpdeskTicketEvents,
  },
  actions: {
    closeModal: raise({ type: 'CLOSE_MODAL' }),
  },
  actors: {
    createTicket: {} as PromiseActorLogic<void, HelpdeskContextContext>,
  },
}).createMachine(
  {
    id: 'update-account-flow',
    initial: 'Closed',
    context: initialState,
    on: {
      CLOSE_MODAL: {
        target: '.Closed',
        actions: assign(initialState),
      },
    },
    states: {
      Creating: {
        invoke: {
          src: 'createTicket',
          input: ({ context }) => context,
          onError: setErrorMessage(),
          onDone: {
            target: 'Success',
          },
        },
      },
      Success: {
        after: {
          5000: { actions: 'closeModal' },
        },
      },
      Error: {
        after: {
          5000: { target: 'Opened' },
        },
      },
      Opened: {
        entry: assign({ modalOpen: () => true }),
        on: {
          CREATE_TICKET: {
            target: 'Creating',
            actions: assign({
              data: ({ event }) => event.data,
            }),
          },
        },
      },
      Closed: {
        on: {
          OPEN_MODAL: {
            target: 'Opened',
            actions: assign(initialState as HelpdeskContextContext),
          },
        },
      },
    },
  },
);
